export const config = {
  debug: process.env.NODE_ENV === "development" ? true : false,
};
